import { connect } from 'react-redux';

import CollectionFilterDrawer from 'components/CollectionFilterDrawer';
import * as actions from 'state/actions';
import CollectionPage from 'state/selectors/collection-page';

const mapStateToProps = (state, ownProps) => {
  const isOpen = CollectionPage.getIsFilterDrawerOpen(state);

  return {
    isOpen,
    ...ownProps,
  };
};

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch(actions.closeCollectionPageFilterDrawer()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CollectionFilterDrawer);
